import type { ReactNode } from "react";
import { useAuth } from "../lib/auth";

export function ModuleGuard({ slug, children }: { slug: string; children: ReactNode }) {
  const { hasModule } = useAuth();
  if (!hasModule(slug)) {
    return (
      <div className="flex h-full items-center justify-center p-8 text-center">
        <div className="max-w-sm rounded-lg border border-tribal-border bg-tribal-surface p-6">
          <h2 className="text-lg font-semibold">Access required</h2>
          <p className="mt-2 text-sm text-tribal-muted">
            You don't have access to the <span className="font-medium text-white">{slug}</span> module.
            Ask an admin to grant it under <span className="font-mono">/admin</span>.
          </p>
        </div>
      </div>
    );
  }
  return <>{children}</>;
}
